<template>
  <div :class="['wrapper', classes]">
    <!-- Horizontal bar at top. Contains messages, notifications, tasks and user menu -->
    <dash-header :user="user"></dash-header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          <span v-if="flag === 'es'">{{ $route.meta.nameEs.toUpperCase() }}</span>
          <span v-else-if="flag === 'de'">{{ $route.meta.nameDe.toUpperCase() }}</span>
          <span v-else-if="flag === 'us'">{{ $route.meta.nameEn.toUpperCase() }}</span>
          <span v-else>{{ $route.meta.namePtbr.toUpperCase() }}</span>
          <small v-if="flag === 'es'">{{ $route.meta.descriptionEs }}</small>
          <small v-else-if="flag === 'de'">{{ $route.meta.descriptionDe }}</small>
          <small v-else-if="flag === 'us'">{{ $route.meta.descriptionEn }}</small>
          <small v-else>{{ $route.meta.descriptionPtbr }}</small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Grupo Naro</a>
          </li>
          <li class="active" v-if="flag === 'es'">{{ $route.meta.nameEs.toUpperCase() }}
          <li class="active" v-else-if="flag === 'de'">{{ $route.meta.nameDe.toUpperCase() }}</li>
          <li class="active" v-else-if="flag === 'us'">{{ $route.meta.nameEn.toUpperCase() }}</li>
          <li class="active" v-else></li>{{ $route.meta.namePtbr.toUpperCase() }}</li>
        </ol>
      </section>
  
      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->
  
    <!-- Horizontal bar at bottom. Contains copy right -->
    <dash-footer></dash-footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './layout/Sidebar'
import DashHeader from './layout/DashHeader'
import DashFooter from './layout/DashFooter'
import 'hideseek'

export default {
  name: 'Dash',
  components: {
    DashHeader,
    DashFooter,
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    flag () {
      return this.$store.state.flag
    },
    user () {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        roles: [this.$store.state.user.email]
      }
    },
    demo () {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      }
    }
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    }
  }
}
</script>

<style>
.wrapper.fixed_layout .main-header {
  position: fixed;
  width: 100%;
}
.wrapper.fixed_layout .content-wrapper {
  padding-top: 50px;
}
.wrapper.fixed_layout .main-sidebar {
  position: fixed;
  height: 100vh;
}

@media (max-width: 767px) {
  .wrapper.hide_logo .main-header .logo {
    display: none;
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}
.logo-mini img,
.logo-lg img {
  padding: 0.4em !important;
}

.logo-lg img {
  display: -webkit-inline-box;
  width: 25%;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?2e5632bf